(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-sales-chat-test"]) return;
  try {
    
  document.querySelectorAll('[id^="PreSalesChat-"]').forEach((root) => {
    const form = root.querySelector('form');
    const input = root.querySelector('textarea');
    const messages = root.querySelector('.pre-sales-chat-test__messages');
    const submit = form.querySelector('button[type="submit"]');
    const storageKey = `${root.id}:conversation`;
    const streamEndpoint = root.dataset.streamEndpoint || `${root.dataset.endpoint}/stream`;

    const appendInlineMarkdown = (element, text) => {
      const tokens = /(\*\*([^*]+)\*\*|\*([^*]+)\*|`([^`]+)`|\[([^\]]+)\]\((https:\/\/[^\s)]+)\))/g;
      let position = 0;
      let match;

      while ((match = tokens.exec(text)) !== null) {
        element.append(document.createTextNode(text.slice(position, match.index)));

        if (match[2]) {
          const strong = document.createElement('strong');
          strong.textContent = match[2];
          element.append(strong);
        } else if (match[3]) {
          const emphasis = document.createElement('em');
          emphasis.textContent = match[3];
          element.append(emphasis);
        } else if (match[4]) {
          const code = document.createElement('code');
          code.textContent = match[4];
          element.append(code);
        } else if (match[5]) {
          try {
            const url = new URL(match[6]);
            if (url.hostname === 'clevinoo.com' || url.hostname === 'www.clevinoo.com') {
              const link = document.createElement('a');
              link.href = url.href;
              link.target = '_blank';
              link.rel = 'noopener noreferrer';
              link.textContent = match[5];
              element.append(link);
            } else {
              element.append(document.createTextNode(match[0]));
            }
          } catch (error) {
            element.append(document.createTextNode(match[0]));
          }
        }

        position = tokens.lastIndex;
      }

      element.append(document.createTextNode(text.slice(position)));
    };

    const appendMarkdown = (element, markdown) => {
      const lines = markdown.replace(/\r\n?/g, '\n').split('\n');
      let paragraph = [];
      let list;
      let listType;

      const flushParagraph = () => {
        if (!paragraph.length) return;
        const node = document.createElement('p');
        paragraph.forEach((line, index) => {
          if (index) node.append(document.createElement('br'));
          appendInlineMarkdown(node, line);
        });
        element.append(node);
        paragraph = [];
      };

      const flushList = () => {
        if (list) element.append(list);
        list = undefined;
        listType = undefined;
      };

      lines.forEach((line) => {
        const unordered = line.match(/^[-*+]\s+(.+)$/);
        const ordered = line.match(/^\d+[.)]\s+(.+)$/);

        if (unordered || ordered) {
          flushParagraph();
          const nextListType = ordered ? 'ol' : 'ul';
          if (!list || listType !== nextListType) {
            flushList();
            list = document.createElement(nextListType);
            listType = nextListType;
          }

          const item = document.createElement('li');
          appendInlineMarkdown(item, (unordered || ordered)[1]);
          list.append(item);
          return;
        }

        flushList();
        if (!line.trim()) {
          flushParagraph();
          return;
        }

        const heading = line.match(/^(#{1,6})\s+(.+)$/);
        if (heading) {
          flushParagraph();
          const node = document.createElement(`h${heading[1].length}`);
          appendInlineMarkdown(node, heading[2]);
          element.append(node);
          return;
        }

        paragraph.push(line);
      });

      flushParagraph();
      flushList();
    };

    const appendMessage = (text, role) => {
      const message = document.createElement('div');
      message.className = `pre-sales-chat-test__message pre-sales-chat-test__message--${role}`;
      if (role === 'assistant') {
        appendMarkdown(message, text);
      } else {
        message.textContent = text;
      }
      messages.append(message);
      message.scrollIntoView({ block: 'nearest' });
      return message;
    };

    const renderAssistantMarkdown = (message, markdown) => {
      message.replaceChildren();
      appendMarkdown(message, markdown);
    };

    const addWaitingAnimation = (message) => {
      message.classList.add('pre-sales-chat-test__message--waiting');
      const loading = document.createElement('span');
      loading.className = 'pre-sales-chat-test__loading';
      loading.setAttribute('aria-hidden', 'true');

      for (let index = 0; index < 3; index += 1) {
        const dot = document.createElement('span');
        dot.className = 'pre-sales-chat-test__loading-dot';
        loading.append(dot);
      }

      message.append(loading);
    };

    const readEventStream = async (response, onEvent) => {
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      const processEvents = () => {
        let boundary;
        while ((boundary = buffer.indexOf('\n\n')) >= 0) {
          const rawEvent = buffer.slice(0, boundary).replace(/\r/g, '');
          buffer = buffer.slice(boundary + 2);
          let eventName = 'message';
          const data = [];

          rawEvent.split('\n').forEach((line) => {
            if (line.startsWith('event:')) eventName = line.slice(6).trim();
            if (line.startsWith('data:')) data.push(line.slice(5).trimStart());
          });

          if (data.length) onEvent(eventName, JSON.parse(data.join('\n')));
        }
      };

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        processEvents();
      }

      buffer += decoder.decode();
      processEvents();
    };

    input.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' || event.shiftKey || event.isComposing) return;

      event.preventDefault();
      form.requestSubmit();
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const message = input.value.trim();
      if (!message) return;

      appendMessage(message, 'user');
      input.value = '';
      input.disabled = true;
      submit.disabled = true;
      const waiting = appendMessage(root.dataset.waiting, 'assistant');
      addWaitingAnimation(waiting);

      try {
        const response = await fetch(streamEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            message,
            conversationId: sessionStorage.getItem(storageKey),
          }),
        });
        if (!response.ok || !response.body) throw new Error('Pre-sales chat request failed');

        let answer = '';
        let conversationId;
        let receivedText = false;
        await readEventStream(response, (eventName, payload) => {
          if (eventName === 'delta' && typeof payload.text === 'string') {
            if (!receivedText) {
              waiting.classList.remove('pre-sales-chat-test__message--waiting');
              receivedText = true;
            }
            answer += payload.text;
            renderAssistantMarkdown(waiting, answer);
            waiting.scrollIntoView({ block: 'nearest' });
            return;
          }

          if (eventName === 'done' && payload.conversationId) {
            conversationId = payload.conversationId;
            return;
          }

          if (eventName === 'error') throw new Error('Pre-sales chat stream failed');
        });

        if (!answer || !conversationId) throw new Error('Pre-sales chat stream ended unexpectedly');

        renderAssistantMarkdown(waiting, answer);
        sessionStorage.setItem(storageKey, conversationId);
      } catch (error) {
        waiting.classList.remove('pre-sales-chat-test__message--waiting');
        waiting.textContent = root.dataset.error;
      } finally {
        input.disabled = false;
        submit.disabled = false;
        input.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
